var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3411 3.68321L9.02811 8.91121C8.84873 9.05984 8.62307 9.14117 8.39011 9.14117C8.15715 9.14117 7.9315 9.05984 7.75211 8.91121L1.44211 3.68321C1.40826 3.78512 1.39104 3.89182 1.39111 3.99921V11.9992C1.39111 12.2644 1.49647 12.5188 1.68401 12.7063C1.87154 12.8938 2.1259 12.9992 2.39111 12.9992H14.3911C14.6563 12.9992 14.9107 12.8938 15.0982 12.7063C15.2858 12.5188 15.3911 12.2644 15.3911 11.9992V3.99921C15.3915 3.89187 15.3746 3.78517 15.3411 3.68321ZM2.39111 1.99921H14.3911C14.9215 1.99921 15.4303 2.20992 15.8053 2.58499C16.1804 2.96007 16.3911 3.46877 16.3911 3.99921V11.9992C16.3911 12.5296 16.1804 13.0383 15.8053 13.4134C15.4303 13.7885 14.9215 13.9992 14.3911 13.9992H2.39111C1.86068 13.9992 1.35197 13.7885 0.9769 13.4134C0.601827 13.0383 0.391113 12.5296 0.391113 11.9992V3.99921C0.391113 3.46877 0.601827 2.96007 0.9769 2.58499C1.35197 2.20992 1.86068 1.99921 2.39111 1.99921ZM2.18111 2.99921L7.75711 7.60221C7.9357 7.74971 8.15995 7.83065 8.39158 7.8312C8.6232 7.83174 8.84783 7.75187 9.02711 7.60521L14.6591 2.99921H2.18111Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.90b23b3f31eff3a1ffbeebaece3cbb46.svg";
export { ForwardRef as ReactComponent };